// extracted by css-extract-rspack-plugin
export default {"centerState":"Hyw6zv","errorIcon":"NcfTOz","form":"Y4gLud","content":"pgdHOS","row":"MsqKRQ","column":"JroSzP","card":"zR0MxM","cardIcon":"i8coA2","input":"CQbcww"};